/**
 * Implements a single masthead dropdown menu.
 */

import Marionette from "backbone.marionette";
import RoutableBehavior from "../../../behaviors/routable";
import Collection from "../../../collections/menu-items";
import Link from "./link";
import templates from "../../../utils/templates";

const DEFAULTS = {
  className: "nav-item dropdown hidden-xs",
  template: templates.find("masthead", "dropdown"),
  childView: Link,
  childViewContainer: ".nav-item-list",
};

class Dropdown extends Marionette.CompositeView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  behaviors() {
    return [{ behaviorClass: RoutableBehavior }];
  }

  initialize() {
    // create collection from children node
    this.collection = new Collection(this.model.getChildren());
  }
}

export { Dropdown as default };
